import * as React from "react";
import { UsersTableRow } from "./tableRow";
import { TableUsersHeader } from "./tableHeader";
import { UsersCreateButton } from "./createButton";
import { Userdata } from "@/types/user";
import { useGetUsersQuery } from "@/api/users-admin";

const emptyList: Userdata[] = [];
export const UsersTable: React.FC = () => {
  const { data: users = emptyList } = useGetUsersQuery();

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Users</h1>
        </div>
        <UsersCreateButton />
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <TableUsersHeader />
                <tbody className="divide-y divide-gray-200 bg-white">
                  {users.map(user => (
                    <UsersTableRow user={user} key={user.id} />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
